

const Exam_filter_reducer=(state ="all", action)=>{
  switch (action.type) {
    case "all":
      return "all";
    case "collegiate":
      return "collegiate";
    case "live":
      return "live";
    default:
      return state;
  }
}

export default Exam_filter_reducer;